<template>
	<base-modal
		name="planBearbeiten"
		:title="$t('shop.planBearbeiten.title')"
		:save-text="$t('shop.planBearbeiten.button.save')"
		@submit="savePlanChange($event, get('plan').id)"
	>
		<!-- Titel des Plan -->
		<div class="text-body-2 font-weight-medium mb-2">
			{{ $t('shop.planBearbeiten.label.planTitle') }}
		</div>
		<v-text-field
			v-model="get('plan').name"
			name="name"
			:placeholder="$t('shop.planBearbeiten.placeholder.title')"
			:rules="planTitleRules"
			outlined
			dense
			required
			hide-details="auto"
		/>

		<!-- Beschreibung -->
		<div class="text-body-2 font-weight-medium mb-2 mt-4">
			{{ $t('shop.planBearbeiten.label.description') }}
		</div>
		<v-textarea
			v-model="get('plan').description"
			name="description"
			:rules="planDescriptionRules"
			outlined
			dense
			hide-details="auto"
		></v-textarea>

		<!-- Preis des Plans -->
		<div class="text-body-2 font-weight-medium mb-2 mt-4">
			{{ $t('shop.planBearbeiten.label.price') }}
		</div>
		<p class="text-caption grey--text mb-2">{{ $t('shop.planBearbeiten.hint.price') }}</p>
		<v-text-field
			v-model="get('plan').price"
			type="number"
			min="0"
			inputMode="decimal"
			name="price"
			:placeholder="$t('shop.planBearbeiten.placeholder.price')"
			:rules="priceRules"
			outlined
			dense
			required
			hide-details="auto"
		></v-text-field>

		<v-divider class="mt-6 mb-4"></v-divider>

		<!-- Sichtbarkeit -->
		<div class="text-h6 font-weight-bold my-2">{{ $t('shop.planBearbeiten.section.visibility') }}</div>
		<div class="d-flex justify-space-between align-center mt-2">
			<div>
				<span class="body-1">{{ $t('shop.planBearbeiten.label.activatePlan') }}</span>
				<span class="fas fa-check green--text pl-4" v-if="get('plan').active == true"></span>
				<p class="caption grey--text ma-0">{{ $t('shop.planBearbeiten.hint.activatePlan') }}</p>
			</div>
			<div class="d-flex align-center">
				<span class="caption grey--text mr-2">{{ $t('shop.planBearbeiten.noYes') }}</span>
				<v-switch
					name="active"
					v-model="get('plan').active"
					dense
					hide-details
					class="mt-0"
				></v-switch>
			</div>
		</div>
	</base-modal>
</template>

<script>

import APIService from '@/services/api.service';
import {mapGetters} from 'vuex';
export default {
	name: 'planBearbeiten',
	components: {
		BaseModal: () => import('@/components/modal/baseModal')
	},
	data(){
		return {
			plan: null,
			activePlan: null,
			valid: false, 
			priceRules: [
				v => !!v || this.$t('shop.planBearbeiten.validation.priceRequired'),
				v => !isNaN(parseFloat(v)) && !isNaN(v - 0) || this.$t('shop.planBearbeiten.validation.priceFormat'),
				v => v >= 0 || this.$t('shop.planBearbeiten.validation.priceNegative')
			],
			planTitleRules: [
				v => !!v || this.$t('shop.planBearbeiten.validation.titleRequired'),
				v => (v && v.length <= 52) || this.$t('shop.planBearbeiten.validation.titleMaxLength'),
				v => (v && v.length >= 2) || this.$t('shop.planBearbeiten.validation.titleMinLength')
			],
			planDescriptionRules: [
				v => !!v || this.$t('shop.planBearbeiten.validation.descriptionRequired'),
				v => (v && v.length <= 350) || this.$t('shop.planBearbeiten.validation.descriptionMaxLength'),
				v => (v && v.length >= 2) || this.$t('shop.planBearbeiten.validation.descriptionMinLength')
			],
			selectedOption: null,
			selectedPricingOption: Boolean,
		}
	},

	computed:{
	...mapGetters(["get"]),
	},

	methods: {

		itemType(){
			// this.selectedItem = payload.name
			this.selectedPricingOption != this.selectedPricingOption
			console.log("selected item:", this.selectedPricingOption)
		},

		toggleRadio(option) {
			if (this.selectedOption === option) {
				// Wenn dieselbe Option erneut ausgewählt wird, setze sie auf null zurück
				this.selectedOption = null;
			} else {
				this.selectedOption = option;
				// Radiobutton basierend auf dem Ref umschalten
				this.$refs['radio' + option][0].toggle();
			}
		},

		thumbnailUpload(id) {
			setTimeout(() => {
				this.$store.dispatch('uploadFiles',
					{
						endpoint: `/api/v1/videos/${id}/upload`,
						files: { image: this.image },
						metadata: { width: 100, height: 100 },
						message: false
					}
				).then((response) => {
					this.resetForm()
					APIService.setResponse({ message: this.$t('shop.planBearbeiten.message.changesSaved'), color: "blue" });
				}).catch((error) =>{
					APIService.setResponse({ message: ``, color: "red" });
				})
			}, 100);
		},

		shareItem(item, style = 'height="500px" width="100%'){
			const src = `${window.location.protocol}//${window.location.host}/videos/${item.id}`;
			let iframe = '';
			if(item.share){
				iframe = `<iframe ${style}" src="${src}" title="${this.$store.state.main.config.result.site_name}"></iframe>`
			}
			return iframe
		},

		shareLink(item){
			return `${window.location.protocol}//${window.location.host}/videos/${item.id}`;
		},

		publishVideo(id){
			var published = this.$store.state.main.video.result.share
			published != published
			this.$store.dispatch('patch',
				{
					endpoint: `/api/v1/videos/${id}`,
					event: { share: published },
					message: false
				}
			)
		},
		stageVideo(id){
			var staged = this.$store.state.main.video.result.published
			staged != staged
			this.$store.dispatch('patch',
				{
					endpoint: `/api/v1/videos/${id}`,
					event: { published: staged },
					message: false
				}
			)
		},

		copyCodeSnippet(item){
			// var copyText = this.shareItem(this.$store.state.main.video.result)
			navigator.clipboard.writeText(item);
			APIService.setResponse({ message: this.$t('shop.planBearbeiten.message.copied'), color: "blue" })
		},

		close(name) {
			this.$store.dispatch("modal/close", name)
		},

		resetForm(){
			this.image = []
			this.video = []
			this.fileRecordsForUpload = []
		},

		savePlanChange(e, id){
			const object = APIService.getFormData( APIService.getForm(e));

			this.$store.dispatch('patch',
				{
					endpoint: `/api/v1/plans/${id}`,
					event: object,
					state: 'plan',
					message: false
				}
			).then(() => {
				this.$store.dispatch('fetch', { endpoint: '/api/v1/plans', state: 'plan'});
				this.$store.dispatch('fetch', { endpoint: '/api/v1/categories', state: 'categories'});
				this.$store.dispatch("modal/close", 'planBearbeiten');
				APIService.setResponse({message: this.$t('shop.planBearbeiten.message.changeSaved'), color: "green"});
			}).catch((error) =>{
				const {response: {status} } = error;
			})
		}
	}, 

	mounted(){
		this.$store.dispatch('fetch', { endpoint: '/api/v1/plans', state: 'plans'});
	}
}
</script>
